import { IStateTask } from 'src/entity/StateEntity';
import { STATUS_SUCCESS, STATUS_PROGRESS, STATUS_ERROR, STATUS_FAILURE } from 'src/constants/ActionTypes';

const initialState: IStateTask = {
  type: STATUS_SUCCESS,
};

export const taskState = (state: IStateTask = initialState, action: IStateTask): IStateTask => {
  switch (action.type) {
    case STATUS_PROGRESS:
      return Object.assign({}, state, {
        type: action.type,
        taskid: action.taskid,
        percentage: action.percentage,
      });
    case STATUS_SUCCESS:
      return Object.assign({}, state, {
        type: action.type,
        taskid: action.taskid,
        result: action.result,
      });
    case STATUS_ERROR:
    case STATUS_FAILURE:
      return Object.assign({}, state, {
        type: action.type,
        taskid: action.taskid,
        errors: action.errors,
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/taskState.ts